export const clientsApi = process.env.REACT_APP_VAULT_API_URL + '/api/clients';
export const scopesApi = process.env.REACT_APP_VAULT_API_URL + '/api/scopes';
export const logoutApi = process.env.REACT_APP_CAS_TOKEN_API_URL + '/logout';
export const sessionUserApi = process.env.REACT_APP_VAULT_API_URL + '/api/session/user';
export const tokenAPI = process.env.REACT_APP_CAS_TOKEN_API_URL + '/oauth2/token';
export const authorizeAPI = process.env.REACT_APP_CAS_TOKEN_API_URL + '/oauth2/authorize';
export const systemContextsApi = process.env.REACT_APP_VAULT_API_URL + '/api/systemcontext/systemcontexts';
